import React, {Component,PureComponent} from 'react';
import {Field, reduxForm, FieldArray} from 'redux-form'
import {Row, Form, Button, Icon, Input, Divider} from 'antd';
import {RTLCol,RTLButton} from '../RTLKit';

/* ------ Field -------- */
import TextField from '../formFields/TextField';
import SelectField from '../formFields/SelectField';
import SelectFieldForLoadCity from '../formFields/SelectFieldForLoadCity';
import SelectFieldForLoadState from '../formFields/SelectFieldForLoadState';
import DynamicFieldSet from '../formFields/DynamicFieldSet';

/* ------ Validate / Warn  -------- */
import ValidateForm from './parts/addValidate';
import WarnForm from './parts/addWarn';
import jwtDecode from "jwt-decode";
import Loading from "../loading/loading";
import UploadField from "../formFields/UploadField";
import _ from 'lodash';

class AddEditForm extends Component {
    constructor(props) {
        super(props);

        //---- Detect Add or Edit module
        this.state = {
            mode: this.props.match.params.id ? 'edit' : 'add',
            itemId: this.props.match.params.id ? this.props.match.params.id : null, // item id in edit mode
            cities:[],
            formLayout: 'horizontal',
            role:this.props.userValue ? this.props.userValue.rl : null,
            myRole: null,
            // branchStateId : this.props.initialValues && this.props.initialValues.branch_operator_state ? this.props.initialValues.branch_operator_state._id : null
            branchStateIdShow : true
        };

    }

    onFormSubmit(value) {
        this.props.handleSubmit(value);
    }

    componentWillMount() {
        this.props.getAreaList();
        if (this.props.match.params.id){
            let id = this.props.match.params.id;
            this.props.getItem(id)
        }
    }

    __getUserRole() {
        let role = this.state.role

        if(!role){
            const userData = jwtDecode(this.props.userValue);
            role = userData.rl
        }

        switch (role) {
            case 'SUPERADMIN':
                return [
                    {label: "مدیر سایت", value: "ADMIN"},
                    {label: "تکنسین", value: "TECHNICIAN"},
                    {label: "اپراتور", value: "OPERATOR"}];

            case 'ADMIN':
                return [
                    {label: "تکنسین", value: "TECHNICIAN"},
                    {label: "اپراتور", value: "OPERATOR"}];

            case 'OPERATOR':
                return [
                    {label: "تکنسین", value: "TECHNICIAN"}];


            default:
                return '';

        }
    }

    __getAreaStateList() {
        let areaList = this.props.areaList;
        let dataSource = [];

        if (areaList) {

            for (let i = 0; i < areaList.length; i++) {

                dataSource.push(
                    {label: areaList[i].title, value: areaList[i]._id, key: i,cities:areaList[i].cities}
                );

            }

        }
        return dataSource;
    }

    __fixCitiesObject(list) {
        let dataSource = [];
        if (list) {
            for (let i = 0; i < list.length; i++) {
                dataSource.push(
                    {label: list[i].title, value: list[i]._id, key: i}
                );
            }
        }
        return dataSource;
    }

    __changeBranchState(branchStateId){
        this.setState({
            branchStateId : branchStateId,
            branchStateIdShow:false
        })
    }

    __getAddressList(list) {//this.props._reduxForm.userList.lists[0]
        let dataSource = [
            {label: 'آدرس جدید', value: 1, key: 1}
        ];
        if (list) {
            for (let i = 0; i < list.length; i++) {
                dataSource.push(
                    {label: list[i].text, value: list[i]._id, key: list[i]._id}
                );
            }
        }
        return dataSource;
    }

    __chooseAddress(val){
        if(val != 1) {
            var address = _.find(this.props.initialValues.addresses, function (obj) {
                return obj._id === val;
            });
            this.setState({stateId: address.stateId, cityId: address.cityId,text:address.text,tag:address.tag})
        }else
            this.setState({stateId: '', cityId: '',tag:'',text:''})

        if(val === 1)
            this.setState({new_address : true, chooseAddress: false})
        else {
            this.setState({new_address: false, chooseAddress: true})
        }
    }

    render() {
        var _self = this;
        const {formLayout} = this.state;
        let role;

        /*---- set mode ---*/
        if(this.props.initialValues) {
            this.props.initialValues.mode=this.state.mode
        }

        /* ----- Get List of state -----*/
        var stateList = this.__getAreaStateList();

        /* ----- find selected state  -----*/
        if(this.props.initialValues && this.state.mode == 'edit') {
            role = this.props.initialValues.role
            if(this.props.initialValues.branch_operator_state && this.state.branchStateIdShow)
                this.state.branchStateId = this.props.initialValues.branch_operator_state._id
        }


        /*--- this parameter use in add user ---*/
        var branchCityList = [];

        /* ----- find selected branch city  -----*/
        if (this.props.initialValues && this.state.mode == 'edit' && this.props.initialValues.branch_operator_cities) {
            let cities = this.props.initialValues.branch_operator_cities;
            var citiesTitle = [];
            var citiesId = [];
            for (let i = 0; i < cities.length ; i++) {
                if(cities[i] && cities[i]['_id']) {
                    citiesTitle.push(cities[i]['_id']);
                    citiesId.push(cities[i]['_id']);
                }
            }
        }

        if (this.state.branchStateId) {
            for (let i = 0; i < stateList.length; i++) {
                if (stateList[i]['value'] == this.state.branchStateId) {
                    branchCityList = stateList[i]['cities'];
                    branchCityList = _self.__fixCitiesObject(branchCityList); //-- fix city object for Selecbox field
                }
            }
        }

        var cityList = [];
        if(this.state.stateId)
        {
            for(let i  = 0;i< stateList.length ; i++)
            {
                if (stateList[i]['value'] == this.state.stateId)
                {
                    cityList = stateList[i]['cities'];
                    cityList = _self.__fixCitiesObject(cityList); //-- fix city object for Selecbox field
                }
            }
        }

        return (
            <Form layout={formLayout} mode={this.state.mode} onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                <Row>
                    <Divider orientation="left">{this.state.mode == 'edit' ? "ویرایش" : "ایجاد"} کاربر</Divider>
                </Row>
                {this.state.mode == 'edit' ?
                    <Loading list={this.props.initialValues} />
                : null}
                <Row type="flex" justify="start" align="middle">
                    <RTLCol md={18} sm={24} type="flex" justify="start" align="middle" >
                        <Row gutter={16}>

                            <Field
                                name="name"
                                component={TextField}
                                type="text"
                                label="نام"
                                placeholder="نام"
                            />
                            <Field
                                name="family"
                                component={TextField}
                                type="text"
                                label="نام خانوادگی"
                                placeholder="نام خانوادگی"
                            />
                            <Field
                                name="username"
                                component={TextField}
                                type="text"
                                label="نام کاربری"
                                placeholder="نام کاربری"
                                disabled = {(this.state.mode == 'edit' )? 'disabled' : null}
                                help="نام کاربری میبایست فقط شامل حروف انگلیسی و اعداد باشد"
                            />
                            <Field
                                name="passwd"
                                component={TextField}
                                type="password"
                                label="رمز عبور"
                                placeholder="رمز عبور"
                            />
                            <Field
                                name="mobile"
                                component={TextField}
                                type="text"
                                maxLength={11}
                                label="شماره همراه"
                                placeholder="شماره همراه"
                                // disabled = {(this.state.mode == 'edit' )? 'disabled' : null}
                            />
                            <Field
                                name="phone_number"
                                component={TextField}
                                type="text"
                                label="شماره تلفن"
                                placeholder="شماره تلفن"
                            />

                            {this.props.initialValues && this.props.initialValues.addresses.length > 0 ?
                                <Field
                                    name="address"
                                    component={SelectField}
                                    type="text"
                                    label="آدرس ها"
                                    placeholder="آدرس"
                                    list={this.__getAddressList(this.props.initialValues.addresses)}
                                    onChange={(val) => this.__chooseAddress(val)}
                                />
                                :
                                <div>
                                    <Field
                                        name="tag"
                                        component={TextField}
                                        type="text"
                                        label="برچسب"
                                        required={true}
                                        placeholder="برچسب به عنوان مثال خانه ، شرکت"
                                    />
                                    <Field
                                        name="new_address"
                                        component={TextField}
                                        type="text"
                                        label="آدرس"
                                        required={true}
                                        placeholder="آدرس"
                                    />
                                </div>
                            }
                            <Field
                                name="stateId"
                                component={SelectFieldForLoadState}
                                label="استان"
                                list={stateList}
                                onChangeVal={(stateId) => {
                                    _self.setState({stateId: stateId})
                                }}
                                defaultValue={this.state.stateId ? this.state.stateId : ''}
                            />
                            <Field
                                name="cityId"
                                component={SelectFieldForLoadCity}
                                label="شهر"
                                list={cityList}
                                defaultValue={this.state.cityId ? this.state.cityId : ''}
                            />
                            <Field
                                name="tag"
                                component={TextField}
                                type="text"
                                label="برچسب"
                                placeholder="برچسب به عنوان مثال خانه ، شرکت"
                                defaultValue={this.state.tag ? this.state.tag : ''}
                            />
                            <Field
                                name="new_address"
                                component={TextField}
                                type="text"
                                label="آدرس"
                                placeholder="آدرس"
                                defaultValue={this.state.text ? this.state.text : ''}
                            />
                            {/* {this.state.new_address === true ?
                                <div>
                                    <Field
                                        name="tag"
                                        component={TextField}
                                        type="text"
                                        label="برچسب"
                                        placeholder="برچسب به عنوان مثال خانه ، شرکت"
                                    />
                                    <Field
                                        name="new_address"
                                        component={TextField}
                                        type="text"
                                        label="آدرس"
                                        placeholder="آدرس"
                                    />
                                </div>
                            :null} */}

                            {(this.state.mode == 'add' )?
                            <Field
                                name="role"
                                component={SelectField}
                                label="نوع کاربری"
                                list={this.__getUserRole()}
                                onChange={(role) => {_self.setState({myRole : role})} }
                            />
                            :null}
                            {(this.state.mode === 'add' && this.state.myRole === 'TECHNICIAN' ) || (this.state.mode === 'edit' && role === 'TECHNICIAN' )?
                             <Field
                                name="branch_state"
                                component={SelectFieldForLoadState}
                                label="استان محل سرویس"
                                list={stateList}
                                onChangeVal={(branchStateId) => this.__changeBranchState(branchStateId)  }
                                defaultValue={(this.props.initialValues && this.props.initialValues.branch_operator_state ? this.props.initialValues.branch_operator_state.title : null)}
                            />
                                :null}
                            {(branchCityList && branchCityList.length > 0) || (this.state.mode === 'edit' && role === 'TECHNICIAN' )?
                            <Field
                                name="branch_city"
                                component={SelectFieldForLoadCity}
                                label="شهر محل سرویس"
                                list={branchCityList}
                                mode="multiple"
                                defaultValue={(this.props.initialValues && this.props.initialValues.branch_operator_cities && this.props.initialValues.branch_operator_cities.length > 0 ? citiesTitle : null)}
                            />
                            :null}
                            {/*{this.state.mode === 'edit' ?*/}
                            {/*    <Field*/}
                            {/*        name="branch_city_id"*/}
                            {/*        component={SelectFieldForLoadCity}*/}
                            {/*        list={branchCityList}*/}
                            {/*        mode="multiple"*/}
                            {/*        defaultValue={(this.props.initialValues && this.props.initialValues.branch_operator_cities && this.props.initialValues.branch_operator_cities.length > 0 ? citiesId : null)}*/}
                            {/*    />*/}
                            {/*:null}*/}
                            {this.state.mode === 'edit' ?
                                <Field
                                    name="is_active"
                                    component={SelectField}
                                    label="وضعیت"
                                    placeholder="وضعیت"
                                    list={[
                                        {label:'فعال',value:1,i:1},
                                        {label:'غیر فعال',value:2,i:2},
                                    ]}
                                    defaultValue={(this.props.initialValues && this.props.initialValues.is_active ? 1 : 2)}
                                />
                            :null}
                            {(this.state.mode === 'add' && this.state.myRole === 'TECHNICIAN' ) || (this.state.mode === 'edit' && role === 'TECHNICIAN' ) ?
                                <RTLCol>
                                    <Field
                                        name="avatar"
                                        component={UploadField}
                                        type="file"
                                        token={this.props.userValue}
                                        label="تصویر تکنسین"
                                        placeholder="تصویر تکنسین"
                                        defaultValue={this.props.initialValues ? this.props.initialValues.avatar : null}
                                        help="سایز عکس میبایست حتما 150*150 پیکسل و با فرمت png باشد"
                                    />
                                </RTLCol>
                            : null}
                        </Row>
                        <Row>
                            <RTLButton loading={this.props.common.isProgressing} type="primary"  shape="round" htmlType="submit" className="login-form-button">
                                {this.state.mode == 'edit' ? "ویرایش" : "ایجاد"}
                            </RTLButton>
                            <RTLButton href="#/user/list"  className="backBtn" type="default" shape="round">
                                بازگشت
                            </RTLButton>
                        </Row>
                    </RTLCol>
                </Row>
            </Form>

        );
    }

}

export default AddEditForm = reduxForm({
    form: 'addUser',        // <--- a unique name for the form
    validate: ValidateForm, // <--- validation function given to redux-form
    warn: WarnForm
})(AddEditForm)
